<template>
  <div class="container mx-auto">
    <div class="flex justify-center">
      <div class="text-sm  pt-6 pb-5">{{title}}</div>
    </div>
    <div class="flex justify-center">
      <h1 class="text-3xl pb-6">結果</h1>
    </div>
    <hr>
    <div class="flex flex-col h-80 mt-5">
      <div class="flex justify-center pt-5 ">
        <div class="pr-10">順位</div>
        <div>
          <span v-if="!loading" :class="`no-${userRunk.rank_num}`"><el-icon :size="20" color="#F9A825" v-if="userRunk.rank_num==1" class="animate__animated animate__swing animate__infinite"><trophy /></el-icon>{{userRunk.rank_num}}位</span><span class="subtext">/{{userRunk.user_count}}人中</span>
        </div>
      </div>
      <div class="flex justify-center">
        <hr class="w-80">
      </div>
      <div class="flex justify-center pt-5">
        <div class="pr-10">累計損益</div>
        <div v-if="!loading" :class="`sign${Math.sign(userRunk.total_profitloss)}`">{{ addComma(userRunk.total_profitloss) }}</div>
      </div>
      <div class="flex justify-center">
        <hr class="w-80">
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent} from 'vue'
import { Trophy } from '@element-plus/icons-vue'
export default defineComponent({
  props: {
    title: { type: String, default: '' },
    loading: { type: Boolean, default: false, required: true },
    userRunk: { type: Object, required: true },
  },
  components: {
    Trophy,
  },
  setup() {
    const addComma = (val) =>{
      if (typeof val == 'number') {
        let result = val.toLocaleString(undefined, { maximumFractionDigits: 5 })
        if (Math.sign(val) == 1) {
          result = `+${result}`
        }
        return result
      }
    }
    return {
      addComma,
      Trophy
    }
  },
})
</script>

<style scoped>
.card-result-text {
  font-size: 1.5em;
}
.card-result-m {
  margin: 1.5em 0;
}
.card-result-boder {
  border-bottom: 1px solid #ebeef5;
}
.card-result-mr {
  margin-right:  0.5em;
}
.subtext {
  font-size: 0.6em;
}
.jump-icon {
  margin-right: 3px;
  animation: jump-icon 2s infinite;
}
@keyframes jump-icon {
  0% { transform:translateY(0) }
  5% { transform:translateY(0) }
  10% { transform:translateY(0) }
  20% { transform:translateY(-10px) }
  25% { transform:translateY(0) }
  30% { transform:translateY(-5px) }
  50% { transform:translateY(0) }
  100% { transform:translateY(0) }
}
</style>

<style scoped>
.sign1 {
  color: #EF5350;
}
.sign-1 {
  color: #039BE5;
}
.sign0 {
  color: #26A69A;
}
.no-1 {
  color: #F9A825;
}
</style>